import { render, staticRenderFns } from "./Profil.vue?vue&type=template&id=2f0075ef&scoped=true&"
import script from "./Profil.vue?vue&type=script&lang=js&"
export * from "./Profil.vue?vue&type=script&lang=js&"
import style0 from "./Profil.vue?vue&type=style&index=0&id=2f0075ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0075ef",
  null
  
)

component.options.__file = "Profil.vue"
export default component.exports